export const QA_NAME_EMAIL_TEST_VARIABLES_CONFIRMATION_MODAL = 'confirmation'
